// Which sale vehicles a REGULAR promotional photo or a watermark applies to.
export const VehicleSelectionMode = {
  ALL_VEHICLES: 'ALL_VEHICLES',
  BY_CONDITIONS: 'BY_CONDITIONS',
} as const;

export type VehicleSelectionMode = (typeof VehicleSelectionMode)[keyof typeof VehicleSelectionMode];
